import React from 'react';
import {
  Container, Typography, Grid, Card, CardContent,
  Box, List, ListItem, ListItemIcon, ListItemText, Paper, Button
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TabletIcon from '@mui/icons-material/Tablet';
import SecurityIcon from '@mui/icons-material/Security';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';
import SpeedIcon from '@mui/icons-material/Speed';

const services = [
  'Screen & digitizer replacement',
  'Battery replacement',
  'Charging port repair',
  'Camera repair and replacement',
  'Speaker and microphone repair',
  'Water / liquid damage treatment',
  'Button and power switch repair',
  'Software reset and OS reinstall',
  'Data recovery and backup',
  'SIM card tray repair',
  'Wi-Fi and Bluetooth antenna repair',
  'Smart connector repair (iPad Pro)',
];

const benefits = [
  {
    icon: TabletIcon,
    title: 'All Brands',
    description: 'iPad, Samsung Tab, Surface, Lenovo, and more',
  },
  {
    icon: SecurityIcon,
    title: 'Data Protected',
    description: 'Your data remains secure throughout the repair process',
  },
  {
    icon: BatteryChargingFullIcon,
    title: 'Quality Parts',
    description: 'Genuine-grade replacement screens and batteries',
  },
  {
    icon: SpeedIcon,
    title: 'Same-Day Options',
    description: 'Many tablet repairs completed the same day',
  },
];

const deviceTypes = [
  { title: 'iPad', description: 'All iPad, iPad Air, iPad Pro, and iPad mini models' },
  { title: 'Samsung Tablets', description: 'Galaxy Tab S, A, and E series' },
  { title: 'Microsoft Surface', description: 'Surface Pro, Surface Go, Surface Duo' },
  { title: 'Android Tablets', description: 'Lenovo, Huawei, Amazon Fire, and others' },
];

function TabletRepair() {
  return (
    <Box sx={{ py: 6, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography variant="h2" component="h1" className="gradient-text" sx={{ mb: 3 }}>
            Tablet Repair Services
          </Typography>
          <Typography variant="h5" sx={{ color: 'text.secondary', mb: 4 }}>
            Expert repair for iPads, Samsung, Surface, and all tablet brands
          </Typography>
          <Button
            component={RouterLink}
            to="/booking"
            variant="contained"
            size="large"
            sx={{
              py: 2, px: 4, fontSize: '1.1rem',
              background: 'linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%)',
              color: '#2d3436', fontWeight: 700,
              '&:hover': {
                background: 'linear-gradient(135deg, var(--primary) 20%, var(--secondary) 80%)',
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 20px rgba(255,107,107,0.3)',
              },
            }}
          >
            Book Tablet Repair
          </Button>
        </Box>

        {/* Benefits */}
        <Grid container spacing={4} sx={{ mb: 8 }}>
          {benefits.map((benefit, i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <Card className="glass-effect card-hover" sx={{ height: '100%' }}>
                <CardContent sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <Box sx={{ mb: 2, color: 'primary.main' }}>
                    {React.createElement(benefit.icon, { sx: { fontSize: 40 } })}
                  </Box>
                  <Typography variant="h6" gutterBottom>{benefit.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{benefit.description}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Services */}
        <Paper elevation={3} sx={{ p: 4, mb: 8, background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(10px)' }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>Our Tablet Repair Services</Typography>
          <Grid container spacing={2}>
            {services.map((service, i) => (
              <Grid item xs={12} sm={6} key={i}>
                <List>
                  <ListItem>
                    <ListItemIcon><CheckCircleIcon color="primary" /></ListItemIcon>
                    <ListItemText primary={service} />
                  </ListItem>
                </List>
              </Grid>
            ))}
          </Grid>
        </Paper>

        {/* Device types */}
        <Paper elevation={3} sx={{ p: 4, background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(10px)' }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>Tablets We Service</Typography>
          <Grid container spacing={3}>
            {deviceTypes.map((type, i) => (
              <Grid item xs={12} sm={6} md={3} key={i}>
                <Card className="glass-effect" sx={{ textAlign: 'center', height: '100%', p: 2 }}>
                  <Typography variant="h6" gutterBottom>{type.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{type.description}</Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
}

export default TabletRepair;
